import React from "react";
import { Menu, User } from "lucide-react";
import logo from "../../assets/images/logo-sulog-rodape.svg";
import { useAuth } from "../../hooks/AuthenticateContext";

interface HeaderProps {
  toggleSidebar: () => void;
  toggleUserSidebar: () => void;
  title: string;
}

const Header: React.FC<HeaderProps> = ({ toggleSidebar, toggleUserSidebar, title }) => {
  const { user } = useAuth();

  return (
    <header className="flex items-center justify-between gap-3 px-3 sm:px-4 h-16 bg-[#003366] text-white shadow-md z-50 relative shrink-0">
      <div className="flex items-center min-w-0 flex-1 sm:w-1/3">
        <button onClick={toggleSidebar} className="p-2 rounded hover:bg-[#004080] mr-2 sm:mr-4 shrink-0" aria-label="Abrir menu">
          <Menu size={24} />
        </button>
        <span className="text-sm sm:text-lg font-medium truncate">{title}</span>
      </div>
      
      <div className="hidden sm:flex flex-1 justify-center w-1/3 min-w-0">
        <img src={logo} alt="Sulog" className="h-8 max-w-full" />
      </div>

      <div 
        className="flex items-center justify-end gap-2 min-w-0 flex-1 sm:w-1/3 cursor-pointer hover:opacity-80"
        onClick={toggleUserSidebar}
      >
        <span className="hidden sm:block text-sm sm:text-base truncate">{user?.nome || "Usuário"}</span>
        <User size={24} className="shrink-0" />
      </div>
    </header>
  );
};

export default Header;
